import { StateCreator } from "zustand";
import { GlobalState } from "../globalStore";
import type { OriginOutput, ActiveSourceType } from "@/core/fastapiClient/sdk";
import appSettings from "@/config/appSettings";

export interface WebsiteGrabState {
  data: OriginOutput | null;
  isLoading: boolean;
  error: string | null;
}

export interface FileGrabState {
  data: OriginOutput | null;
  isLoading: boolean;
  error: string | null;
}

export interface OriginSlice {
  // active source type (tracking which content source was selected)
  activeSourceType: ActiveSourceType;
  setActiveSourceType: (type: ActiveSourceType) => void;
  // grabbed website
  grabbedWebsite: WebsiteGrabState;
  setGrabbedWebsite: (data: OriginOutput | null) => void;
  setGrabbedWebsiteLoading: () => void;
  setGrabbedWebsiteError: (error: string) => void;
  resetGrabbedWebsite: () => void;
  // grabbed file
  grabbedFile: FileGrabState;
  setGrabbedFile: (data: OriginOutput | null) => void;
  setGrabbedFileLoading: () => void;
  setGrabbedFileError: (error: string) => void;
  resetGrabbedFile: () => void;
}

export const createOriginSlice: StateCreator<
  GlobalState,
  [],
  [],
  OriginSlice
> = (set) => ({
  // active source type (tracking which content source was selected)
  activeSourceType: appSettings.default.activeSourceType,
  setActiveSourceType: (type) =>
    set({
      activeSourceType: type,
    }),
  // grabbed website
  grabbedWebsite: {
    data: null,
    isLoading: false,
    error: null,
  },
  setGrabbedWebsite: (data) =>
    set({
      grabbedWebsite: {
        data,
        isLoading: false,
        error: null,
      },
    }),
  setGrabbedWebsiteLoading: () =>
    set((state) => ({
      grabbedWebsite: {
        ...state.grabbedWebsite,
        isLoading: true,
        error: null,
      },
    })),
  setGrabbedWebsiteError: (error) =>
    set((state) => ({
      grabbedWebsite: {
        ...state.grabbedWebsite,
        isLoading: false,
        error,
      },
    })),
  resetGrabbedWebsite: () =>
    set({
      grabbedWebsite: {
        data: null,
        isLoading: false,
        error: null,
      },
    }),
  // grabbed file
  grabbedFile: {
    data: null,
    isLoading: false,
    error: null,
  },
  setGrabbedFile: (data) =>
    set({
      grabbedFile: {
        data,
        isLoading: false,
        error: null,
      },
    }),
  setGrabbedFileLoading: () =>
    set((state) => ({
      grabbedFile: {
        ...state.grabbedFile,
        isLoading: true,
        error: null,
      },
    })),
  setGrabbedFileError: (error) =>
    set((state) => ({
      grabbedFile: {
        ...state.grabbedFile,
        isLoading: false,
        error,
      },
    })),
  resetGrabbedFile: () =>
    set({
      grabbedFile: {
        data: null,
        isLoading: false,
        error: null,
      },
    }),
});
